import React,{useState} from "react";
import {Modal,Button,Form} from "react-bootstrap";

export default function AddProjectModal({
show,
handleClose,
addProject
}){

const [form,setForm]=useState({
title:"",
priority:"Low",
status:"New",
budget:"",
tasks:"",
due:""
});

const handleSubmit=()=>{
addProject(form)
handleClose()
}

return(

<Modal show={show} onHide={handleClose} centered>

<Modal.Header closeButton>
<Modal.Title>Add Project</Modal.Title>
</Modal.Header>

<Modal.Body>

<Form.Control
className="mb-2"
placeholder="Project Title"
onChange={(e)=>setForm({...form,title:e.target.value})}
/>

<Form.Select
className="mb-2"
onChange={(e)=>setForm({...form,priority:e.target.value})}
>
<option>Low</option>
<option>Medium</option>
<option>High</option>
</Form.Select>

<Form.Select
className="mb-2"
onChange={(e)=>setForm({...form,status:e.target.value})}
>
<option>New</option>
<option>Inprogress</option>
<option>On-hold</option>
<option>Completed</option>
</Form.Select>

<Form.Control
className="mb-2"
placeholder="Budget"
/>

<Form.Control
className="mb-2"
placeholder="Tasks"
/>

<Form.Control
className="mb-2"
type="date"
/>

</Modal.Body>

<Modal.Footer>

<Button variant="secondary" onClick={handleClose}>
Cancel
</Button>

<Button onClick={handleSubmit}>
Save
</Button>

</Modal.Footer>

</Modal>

)

}